import { useState, useLayoutEffect, useCallback } from "react";
import { Row, Col } from "react-bootstrap"
import { format, startOfMonth } from "date-fns"
import { Spin, Tabs } from 'antd';
import _ from "lodash"

import 'antd/dist/antd.min.css'
import styles from "../style.module.css"
import "../scss/report.scss"

import StorageService from "../../../utils/storage.service";
import axiosService from "../../../utils/axios.service";

import FilterReport from "../header/FilterReport"
import RatingByStore from "./item/RatingByStore";
import RatingByKtv from "./item/RatingByKtv";

const ReportRating = () => {
    const [title, setTitle] = useState("Báo cáo tổng quan đánh giá")
    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(new Date())), "yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'))
    const [store, setStore] = useState(
        (JSON.parse(StorageService.getItem("user_info")) && JSON.parse(StorageService.getItem("user_info")).role == 3) ?
            [JSON.parse(StorageService.getItem("user_info")).stores[0].id]
        : [parseInt(StorageService.getItem("currentStore"))])
    const [isExport, setIsExport] = useState(false)
    const [loading, setLoading] = useState(true);
    const [ratingByStore, setRatingByStore] = useState([])
    const [ratingByKtv, setRatingByKtv] = useState([])
    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))
    const [keyword, setKeyword] = useState()

    const handleRangeDate = (sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
    }

    const handleStore = useCallback((e) => {
        setStore(e)
    }, [store])

    const fetchData = async (sD, eD, s) => {
        let payload = {
            startDate: sD,
            endDate: eD,
            storeId: s
        }

        const resRating = await axiosService(`api/reports/rating`, "POST", payload)
        
        if (resRating.data.code === 200) {
            setRatingByStore(resRating.data.data.reportByStore)
            setRatingByKtv(resRating.data.data.reportByKtv)
            setLoading(false)
        } else {
            setLoading(false)
        }
        
    }
    useLayoutEffect(() => {
        setLoading(true)
        fetchData(startDate, endDate, store)
    }, [startDate, endDate, store])

   const handleExportData = async () => {
        setLoading(true);

        try {
            const header = {
                store_name: "Cơ sở",
                total_service: "Tổng khách hàng phục vụ",
                total_rating: "Tổng khách hàng rating",
                percent_rating: "Tỷ lệ rating",
                point_average: "Điểm trung bình",
                rating_5: "5 sao",
                rating_4: "4 sao",
                rating_3: "3 sao",
                rating_2: "2 sao",
                rating_1: "1 sao"
            };

            const ratingByStoreData = [
                _.values(header),
                ..._.map(ratingByStore, item => _.values(_.pick(item, _.keys(header))))
            ];

            const header2 = {
                employee_name: "Tên nhân viên",
                total_service: "Tổng khách hàng phục vụ",
                total_rating: "Tổng khách hàng rating",
                percent_rating: "Tỷ lệ rating",
                point_average: "Điểm trung bình",
                rating_5: "5 sao",
                rating_4: "4 sao",
                rating_3: "3 sao",
                rating_2: "2 sao",
                rating_1: "1 sao"
            };

            const ratingByKtvData = [
                _.values(header2),
                ..._.map(ratingByKtv, item => _.values(_.pick(item, _.keys(header2))))
            ];

            const payload = {
                name: "report_rating_",
                sheets: [
                    {
                        name: "Rating theo cơ sở",
                        data: ratingByStoreData
                    },
                    {
                        name: "Rating theo nhân viên",
                        data: ratingByKtvData
                    }
                ]
            };

            const res = await axiosService("api/mysql/export/have-data", "POST", payload);

            if (res.data.code === 200) {
                window.open(res.data.data.url, "_blank");
            }

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };
    
    const onChangeKeyword = (e) => {
        setKeyword(e)
    }

    const tabItems = [
        {
            key: '1',
            label: 'Báo cáo theo cơ sở',
            children: (
                <RatingByStore
                    table={ratingByStore}
                    startDate={startDate}
                    endDate={endDate}
                    store={store}
                />
            ),
        },
        {
            key: '2',
            label: 'Báo cáo theo nhân viên',
            children: (
                <RatingByKtv
                    table={ratingByKtv}
                    startDate={startDate}
                    endDate={endDate}
                    store={store}
                />
            ),
        },
    ];

    return (
        <div className={`container-fluid ${styles.background}`}>
            <FilterReport startDate={startDate} endDate={endDate}
                handleRangeDate={handleRangeDate} store={store}
                handleStore={handleStore}
                title={title} type={"report-rating"}
                csvData={ratingByStore} isExport={isExport}
                handleExportData={handleExportData}
                onChangeKeyword={onChangeKeyword}
                header={
                    [
                        { label: 'Nhân viên', key: "name" },
                        { label: "Số lịch đã đặt", key: "countBooking" },
                        { label: "Số đơn đã hoàn thành từ đặt lịch", key: "countOrder" },
                        { label: "Tổng doanh số", key: `total` }
                    ]
                }
                userAdmin={userAdmin}
            />
            <Spin spinning={loading} tip="Đang tải...">
                <Row className="p-2">
                    <Col xs={12} className="p-2">
                        <div style={{ backgroundColor: "white" }} className="p-2">
                            <Tabs defaultActiveKey="1" items={tabItems} />
                        </div>
                    </Col>
                </Row>
            </Spin>
        </div>
    )
}
export default ReportRating